import React from "react"
import PropTypes from "prop-types"
import { PrintHeader } from "@/components/PartsViewer/v2/icon"

const PrintPage = props => {
  const { item, metadata, index, printItems } = props

  const getFormatedDate = () => {
    const today = new Date()
    return today.toLocaleString("en", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour12: true,
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  return (
    <div rel={index} id="wrap">
      <div id="header" className="topPrint">
        <PrintHeader data={metadata?.Info} />
      </div>
      <div rel="printDiv" className="container" id="main">
        <img src={item?.URL} alt="" srcSet="" />
      </div>
      <div id="footer">
        <div id="pagination">
          Page <span id="actual">{index + 1}</span> - {""}
          <span id="total">{printItems?.length}</span>
        </div>
        <div id="inf-print">
          <p className="date-print">
            printed on <span className="date-print">{getFormatedDate()}</span>
          </p>
        </div>
      </div>
    </div>
  )
}

PrintPage.propTypes = {
  item: PropTypes.object.isRequired,
  metadata: PropTypes.object.isRequired,
  index: PropTypes.string.isRequired,
  printItems: PropTypes.array.isRequired,
}

export default PrintPage
